import { NextSeo } from 'next-seo'
import { propOr } from 'ramda'

import useProgram from '../stores/use-program'

const programSelector = propOr({}, 'program')
const Meta = () => {
  const program = useProgram(programSelector)

  return (
    <NextSeo
      title={program?.seo?.title || program.title}
      description={program?.seo?.description || program?.description}
      keywords={program?.seo?.keywords}
      openGraph={{
        title: program?.seo?.title || program.title,
        description: program?.seo?.description || program?.description,
        images: [{ url: program?.seo?.image || program?.cover?.image }],
        site_name: program?.seo?.title || program.title,
      }}
    />
  )
}

export default Meta
